import { Typography } from '@mui/material';
import { useAmplifyEventSubscribe } from 'core/services/amplify/events/useAmplifyEventSubscribe';

export const ConversationColleagueTyping: React.FC<{
  conversationId: string;
}> = ({ conversationId }) => {
  const { data } = useAmplifyEventSubscribe({
    channelType: 'ConversationTyping',
    channelParams: {
      conversationId
    }
  });

  if (data.length === 0) return null;

  return <Typography>A colleague is typing...</Typography>;
};
